module.exports = __webpack_public_path__ + "static/urban11-6579e2e44c8a252b2ea640c17c56eb69.jpg";